module.exports = __webpack_public_path__ + "img/mistakesText8.8ffdb6f9.png";